import type React from 'react';
import type { FC } from 'react';

import { useTranslation } from '@crehana/i18n';
import { neutralDark, neutralLight } from '@crehana/tailwindcss';
// biome-ignore lint/style/noRestrictedImports: legacy import, will be migrated
import { PrimaryButton } from '@crehana/ui';
import { useUITheme } from '@crehana/web';
import { clsx } from 'clsx';

import Center from '../Center';
import data from './ErrorMessage.data';
import type { ErrorMessageProps } from './types';

const ErrorMessage: FC<React.PropsWithChildren<ErrorMessageProps>> = ({
  className,
  icon: Icon = data.icon,
  title,
  subtitle,
  tryAgainLabel,
  onTryAgain,
  iconSize,
}) => {
  const { t } = useTranslation();
  const { isDark } = useUITheme();

  return (
    <Center className={clsx('flex-col', className)}>
      <div className="tw-rounded-full tw-flex tw-items-center tw-justify-center tw-p-1 tw-mb-1 tw-bg-neutral-light-200 dark:tw-bg-neutral-dark-700">
        <Icon
          size={iconSize ? iconSize / 2 : 24}
          color={isDark ? neutralLight[700] : neutralDark[500]}
        />
      </div>
      <h3 className="tw-font-subtitle5">{title || t(data.title)}</h3>
      <p className="tw-text-center tw-font-body5 mt-8 tw-text-neutral-light-700 dark:tw-text-neutral-dark-200 tw-whitespace-pre">
        {subtitle || t(data.subtitle)}
      </p>
      {onTryAgain && (
        <PrimaryButton
          className="mt-16"
          darkMode={isDark}
          size="s"
          label={tryAgainLabel || t(data.tryAgainLabel)}
          onClick={onTryAgain}
        />
      )}
    </Center>
  );
};

export default ErrorMessage;
